import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const constantRoutes = [{
	path: "/",
	name: "Home",
	meta: {
		title: "首页",
		icon_s: "icon_home_s.png",
		icon_n: "icon_home_n.png"
	},
	component: () => import("@/views/home/home-to.vue"),
}];


const router = new VueRouter({
	scrollBehavior: () => ({
		y: 0,
	}),
	routes: constantRoutes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};

export function resetRouter() {
	router.matcher = new VueRouter({
		scrollBehavior: () => ({
			y: 0,
		}),
		routes: constantRoutes,
	}).matcher;
}

export default router;